function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import styled from 'styled-components';
import { border, borderRadius, height, width } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Box from '../Box';
import { FormGroupContext } from './FormGroup';
const StyledSelect = styled(Box).withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-1rstcru-0"
})(["", " ", " ", " ", " &:hover{border-color:", ";}&:focus{border-color:", ";outline:none;}", " ", " ", ""], border, borderRadius, height, width, themeGet('colors.gray.5'), themeGet('colors.secondary'), props => props.hasError && "&, &:hover, &:focus { border-color: ".concat(themeGet('colors.error')(props), "; }"), props => props.hasPrefix && "\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  ", props => props.hasSuffix && "\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  ");
const hasFormError = (name, form) => {
  return form && form.touched && form.touched[name] && form.errors && form.errors[name];
};
const Select = /*#__PURE__*/memo(_ref => {
  let {
    field,
    form,
    hasError,
    ...props
  } = _ref;
  const id = useContext(FormGroupContext);
  return /*#__PURE__*/React.createElement(StyledSelect, _extends({
    id: id,
    hasError: field ? hasFormError(field.name, form) : hasError
  }, field, props));
});
Select.propTypes = {
  ...Box.propTypes,
  ...border.propTypes,
  ...borderRadius.propTypes,
  ...height.propTypes,
  ...width.propTypes,
  hasPrefix: PropTypes.bool,
  hasSuffix: PropTypes.bool
};
Select.defaultProps = {
  as: 'select',
  py: 2,
  px: 2,
  display: 'block',
  height: 40,
  width: '100%',
  maxWidth: '100%',
  bg: 'white',
  border: 'default',
  borderRadius: 'corner',
  hasError: false,
  hasPrefix: false,
  hasSuffix: false
};
Select.displayName = 'Select';
export default Select;